import {useUnifyAdminStore} from '../../AdminStore';
import {CampaignLinkInputWithHelperText} from '../Blocks/CampaignLinkInputWithHelperText'
import { t } from 'i18next';

export const CampaignLinkField = (): JSX.Element => {
    /**
     * Data Store
     */
    const campaignItems = useUnifyAdminStore((state) => state.campaignItems);
    const updateCreateCampaignData = useUnifyAdminStore((state) => state.updateCreateCampaignData);
    const permissions = useUnifyAdminStore(state => state.permissions); 
    const archiveSwitch = useUnifyAdminStore((state) => state.campaignArchiveSwitch);

    const handleUpdateLinkField = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        return updateCreateCampaignData({
            fieldName: event.target.name,
            value: event.target.value,
        });
    };

    return (
        <>
            <CampaignLinkInputWithHelperText
                dataTestId="campaign-link-input"
                id="campaign-link-abbr-input"
                inputDivider="left"
                label={t('campaigns.campaignLink')}
                name="link"
                onChange={handleUpdateLinkField}
                placeholder={t('campaigns.campaignLinkPlaceholder')}
                value={campaignItems.link}
                isDisabled={archiveSwitch || (campaignItems.id
                    && (!permissions?.hasCampaignUpdatePermissions && !permissions?.hasCampaignSuperAdminPermissions))}
                maxLength={200}
                textLength={`${campaignItems?.link?.length || 0}/200`}
            />
        </>
    );
};
